import { useState } from 'react';

import {
  SegmentedControl,
  SegmentOption,
} from '@ui/components/controls/SegmentedControl/SegmentedControl';
import { FancyModal, FancyPanelAction, FancyPanelTitle } from '@ui/components/panels/FancyPanel';

import styles from './CamerasRequirementModal.module.css';

const OPTIONS: SegmentOption<number>[] = [
  { value: 1, label: 'Одна камера' },
  { value: 2, label: 'Две камеры' },
];

type Props = {
  userName: string;
  count: number;
  onSave: (count: number) => void;
  onClose: () => void;
};

// Выбор числа камер: одна — по умолчанию, две — пишем в aux участника клуба
export function CamerasRequirementModal({ userName, count, onSave, onClose }: Props) {
  const [value, setValue] = useState(count);

  return (
    <FancyModal
      align="center"
      className={styles.modal}
      actions={
        <FancyPanelAction className={styles.modal__save} onClick={() => onSave(value)}>
          Сохранить
        </FancyPanelAction>
      }
      onClose={onClose}
    >
      <FancyPanelTitle>Видеоконтроль</FancyPanelTitle>
      <p className={styles.modal__name}>{userName}</p>
      <SegmentedControl
        className={styles.modal__control}
        options={OPTIONS}
        value={value}
        onChange={setValue}
      />
    </FancyModal>
  );
}
